<!--
 * @Author: 孙照
 * @LastEditTime: 2023-02-16 16:46:11
 * @Description: 近一月充电量与充电次数趋势
 * @FilePath: \fuzhou\src\module\overview\stationChargeModal\components\recentMonthChargePower.vue
-->
<template>
  <div class="recent-month-charge-power">
    <pub-info-title :title="'近1月充电量与充电次数趋势'" :isModal="true" />
    <div ref="Line" class="power-line-chart"></div>
  </div>
</template>
<script>
import pubInfoTitle from '@/components/infoTitle/index.vue';
import * as Echarts from 'echarts';

export default {
  name: 'recentMonthChargePower',
  components: {
    pubInfoTitle,
  },
  data() {
    return {
      chart: null,
    };
  },
  props: {
    graphGradientData: {
      default: () => {},
      type: Object,
    },
  },
  watch: {
    graphGradientData: {
      handler(val) {
        this.lineChartsInit();
      },
      deep: true,
    },
  },
  mounted() {
    this.lineChartsInit();
    window.addEventListener('resize', () => {
      this.chart.resize();
    });
  },
  methods: {
    lineChartsInit() {
      this.chart = Echarts.init(this.$refs.Line);
      const option = {
        tooltip: {
          trigger: 'axis',
          formatter: (params) => {
            let str = `<div>${params[0].name}</div>`;
            params.forEach((item) => {
              str += `<div style='display:flex;'>
                      <div>${item.marker} </div>
                      <div style='width:80px'>${item.seriesName}</div>
                      <div style='font-weight:600;'>${item.value.toFixed(0)}</div>
                    </div>`;
            });
            return str;
          },
        },
        legend: {
          data: ['充电量', '充电次数'],
          itemHeight: this.fitChartSize(0),
          top: this.fitChartSize(-4),
          itemGap: this.fitChartSize(19),
          textStyle: {
            color: '#CCCCCC',
            fontSize: this.fitChartSize(12),
          },
        },
        grid: {
          top: this.fitChartSize(40),
          left: '1%',
          right: '1%',
          bottom: 0,
          containLabel: true,
        },
        xAxis: {
          type: 'category',
          boundaryGap: ['5%', '5%'],
          data: this.graphGradientData.index,
          axisTick: {
            show: false, // x 轴刻度是否显示
          },
          axisLine: {
            show: false,
          },
          axisLabel: {
            color: '#9A9A9A',
            fontSize: this.fitChartSize(12),
            margin: this.fitChartSize(14),
          },
        },
        yAxis: [
          {
            name: 'kWh',
            nameLocation: 'end',
            nameTextStyle: {
              color: '#fff',
              align: 'right',
              fontSize: this.fitChartSize(12),
              padding: [0, 0, 0, 0],
            },
            type: 'value',
            axisLabel: {
              color: '#C5C5C5',
              fontSize: this.fitChartSize(12),
              margin: this.fitChartSize(6),
            },
            splitLine: {
              show: true,
              lineStyle: {
                width: 1,
                color: 'rgba(43, 196, 255, 0.5)',
                type: 'dashed',
              },
            },
          },
          {
            name: '次',
            type: 'value',
            alignTicks: true,
            nameTextStyle: {
              color: '#fff',
              align: 'right',
              fontSize: this.fitChartSize(12),
              padding: [0, this.fitChartSize(-18), 0, 0],
            },
            axisLabel: {
              color: '#C5C5C5',
              fontSize: this.fitChartSize(12),
              margin: this.fitChartSize(6),
            },

            splitLine: {
              show: true,
              lineStyle: {
                width: 1,
                color: 'rgba(43, 196, 255, 0.5)',
                type: 'dashed',
              },
            },
          },
        ],
        series: [
          {
            name: '充电量',
            type: 'line',
            smooth: true,
            symbol: 'none',
            itemStyle: {
              color: '#32BAFF',
              shadowColor: '#32BAFF',
              shadowBlur: 8,

            },
            lineStyle: {
              color: '#32BAFF',
            },
            // 线条下方区域颜色
            areaStyle: {
              color: new Echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: 'rgba(48, 183, 255, 1)',
                },
                {
                  offset: 1,
                  color: 'rgba(3, 132, 255, 0)',
                },
              ]),
            },
            data: this.graphGradientData.chargingCapacity,
          },
          {
            name: '充电次数',
            type: 'line',
            smooth: true,
            symbol: 'none',
            yAxisIndex: 1,
            itemStyle: {
              color: '#FF9C59',
              shadowColor: 'rgba(255, 156, 89, 1)',
              shadowBlur: 8,
            },
            lineStyle: {
              color: '#FF9C59',
            },
            // 线条下方区域颜色
            areaStyle: {
              color: new Echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: 'rgba(255, 156, 89, 1)',
                },
                {
                  offset: 1,
                  color: 'rgba(255, 156, 89, 0)',
                },
              ]),
            },
            data: this.graphGradientData.chargeTimes,

          },
        ],
      };
      this.chart.setOption(option);
    },
  },
};
</script>

<style lang="less" scoped>
.recent-month-charge-power {
  ::v-deep .pub-info-title {
    margin-bottom: 20px;
  }
  .power-line-chart {
    width: 100%;
    height: 247px;
    margin-bottom: 16px;
  }
}
</style>
